
    // THIS FILE IS AUTO-GENERATED via 'yarn build-trans' !!

    export default {
        locale: 'sk_SK',
        messages: {
			"graphical_template": "Grafická šablóna",
			"fill": "Výplň",
			"none": "Žiadny",
			"shape_color": "Farba výplne",
			"shape_position": "Umiestnenie",
			"shape_size": "Veľkosť",
			"triangle": "Trojuholník",
			"square": "Štvorec",
			"square_format": "Štvorcový",
			"wide": "Na šírku",
			"width": "Šírka",
			"stroke_width": "Šírka okraja",
			"stroke_color": "Farba okraja",
			"text_stroke_width": "Šírka ťahu textu",
			"text_stroke_color": "Farba ťahu textu",
			"frame_image": "Orámovať obrázok",
			"color": "Farba",
			"side": "Strana",
			"text": "Text",
			"text_color": "Farba textu",
			"text_fontsize": "Veľkosť písma",
			"text_font": "Font",
			"triangle_orientation": "Orientácia trojuhoľníka",
			"search": "Hľadať",
			"up": "Hore",
			"down": "Dole",
			"show_frame": "Zobraziť rám",
			"dashed": "Čiarkovaný",
			"frame_color": "Farba rámu",
			"frame_width": "Šírka rámu",
			"frame_width_placeholder": "šírka rámu v pixeloch",
			"show_stripe": "Zobraziť pruh",
			"stripe_color": "Farba pruhu",
			"stripe_position": "Umiestnenie pruhu",
			"horizontal": "Horizontálny pruh",
			"vertical": "Vertikálny pruh",
			"stripe_text_placeholder": "Text v pruhu",
			"shape_text_placeholder": "Text vo vrstve",
			"text_size_placeholder": "veľkosť textu",
			"text_font_placeholder": "font",
			"nav_queries": "Produkty",
			"nav_size": "Formát",
			"nav_frame": "Rám",
			"nav_filter": "Filter",
			"nav_stripe": "Pruh",
			"nav_shape": "Vrstva",
			"nav_image": "Obrázok",
			"nav_save": "Uložiť",
			"nav_shapes": "Vrstvy",
			"upscale_image": "Vylepšiť rozlíšenie",
			"template_type_null": "Grafická šablóna",
			"template_type_1": "Vylepšenia rozlíšenia",
			"template_type_2": "Odstrániť pozadie",
			"template_type_3": "Odstránenie vodoznakov",
			"template_type_4": "Outpainting",
			"template_type_5": "Animovaný GIF",
			"template_type_6": "Inpainting",
			"template_type_10": "Obrázok s odstráneným vodoznakom",
			"template_type_11": "Obrázok s odstráneným pozadím",
			"template_type_1_started": "Prebieha vylepšovanie obrázku",
			"template_type_2_started": "Prebieha odstraňovanie pozadia",
			"template_type_3_started": "Prebieha odstraňovanie vodoznaku",
			"template_type_4_started": "Prebieha outpainting",
			"template_type_6_started": "Prebieha inpainting",
			"template_type_1_done": "Obrázok vylepšený",
			"template_type_2_done": "Pozadie obrázku odstránené",
			"template_type_3_done": "Vodoznak odstránený",
			"template_type_4_done": "Outpainting hotový",
			"template_type_6_done": "Inpainting hotový",
			"outpainting_error": "Chyba outpaintingu",
			"outpaint_over": "Náter cez celé plátno",
			"upscale_previews_all_done": "Náhľady boli vygenerované. Pre hromadné vylepšenie rozlíšenia vyberte v pravom panely produktový výber, na ktorý chcete vylepšenia aplikovať. Nezabudnite šablónu pomenovať a uložiť.",
			"min_detection_accuracy": "minimálna presnosť detekcie",
			"min_detection_accuracy_info": "ak bude presnosť detekcie nižšia, ponechá sa pôvodný obrázok s vodoznakom",
			"get_previews": "Vygenerovať náhľady",
			"select_images_for_upscale_previews": "Vyberte obrázky, z ktorých si prajete vytvoriť náhľady vylepšenia rozlíšenia.",
			"creating_upscale_previews": "Generujú sa náhľady obrázkov. Táto operácia je časovo náročná, chvíľu to potrvá.",
			"sending_images_for_upscale_previews": "Odosielam obrázky",
			"original_image": "Pôvodný obrázok",
			"other_images": "Iné obrázky",
			"bgremoved_image": "Upravený obrázok s odstráneným pozadím",
			"bgremoved_edited_image": "Obrázok s odstráneným pozadím",
			"wmremoved_image": "Obrázok s odstráneným vodoznakom",
			"upscaled_image": "Vylepšený obrázok",
			"no_images_for_upscale": "Vo vašom feede sme nenašli žiadne obrázky s rozmermi do 600 x 600 pixelov. Velepšenie rozlíšenia nie je nutné.",
			"upscale_template": "Vylepšenie rozlíšenia obrázkov",
			"upscale_how_does_it_work": "<h3>Ako to funguje</h3><p>....</p>",
			"upscale_method_preview": "Ukážky vylepšenia rozlíšenia",
			"image_is_upscaled": "Obrázok s vylepšeným rozlíšením",
			"show_larger_preview": "Zobraziť väčší náhľad",
			"upscale_loading_products": "Analyzujeme rozmery obrázkov vo vašom feede. Vylepšenie rozlíšenie má zmysel iba pre obrázky s rozmermi do 600 x 600 pixelov.",
			"upscale_clear_interval": "Zrušiť a vybrať iné obrázky",
			"clear_selection": "Zrušiť výber",
			"selected_count": "Vybraných",
			"cancel": "Zrušiť",
			"position": "Pozícia",
			"opacity": "Priehľadnosť",
			"apply_on_queries": "Aplikovať na produkty",
			"template_name": "Názov šablóny",
			"template_type": "Typ",
			"save_template": "Uložiť šablónu",
			"show_shape": "Zobraziť vrstvu",
			"stroke_opacity": "Priehľadnosť okraju",
			"priority": "Priorita",
			"template_list": "Zoznam šablón",
			"products": "Produkty",
			"images": "Obrázky",
			"count_images": "počet obrázkov",
			"validations": "Validácia obrázkov",
			"new_template": "Nová šablóna",
			"new_upscale_template": "Vylepšenie rozlíšenia obrázkov",
			"new_bgremove_template": "Odstránenie pozadia",
			"new_wmremove_template": "Odstránenie vodoznaku",
			"template_gallery": "Galéria šablón",
			"blank_template": "Prázdna šablóna",
			"background_color": "Farba pozadia",
			"text_background_color": "Farba pozadia",
			"background_width": "Šírka",
			"background_height": "Výška",
			"background_type": "Typ pozadia",
			"background_type_none": "Žiadne",
			"background_type_circle": "Koliesko",
			"background_type_rectangle": "Obdĺžnik",
			"background_type_rectangle-each-line": "Obdĺžnik na každý riadok",
			"background_type_ellipse": "Elipsa",
			"background_type_image": "Obrázok",
			"random_product": "Náhodný produkt",
			"stroke": "Okraj",
			"full": "Plný",
			"no_templates": "Zatiaľ nemáte žiadne šablóny. Vytvorte prvú!",
			"no_alternative_templates": "Zatiaľ nemáte žiadne alternatívne šablóny.",
			"all_products": "Všetky produkty",
			"back": "Späť",
			"back_to_template_list": "Späť na zoznam šablón",
			"due_date": "Termín",
			"created_at": "Vytvorené",
			"save": "Uložiť",
			"save_and_exit": "Uložiť a odísť",
			"save_and_apply": "Uložit a použiť",
			"save_as_new_template": "Uložiť ako novú šablónu",
			"apply": "Aplikovať",
			"saving": "Ukládá sa",
			"no_shape_selected": "Nebola vybraná žiadna vrstva.",
			"user": "Užívateľ",
			"delete": "Zmazať",
			"insert": "Vložiť",
			"preview": "Náhľad",
			"pause": "Pozastavit",
			"start": "Spustiť",
			"action": "Akcia",
			"edit": "Upraviť",
			"next": "Nasledujúci",
			"previous": "Predchádzajúci",
			"project": "Export",
			"eshop": "Eshop",
			"agency": "Agentúra",
			"freelancer": "Freelancer",
			"title": "Nadpis",
			"date": "Dátum",
			"created_by": "Vytvoril",
			"max_length": "Maximálna dĺžka: 1000 znakov",
			"chars_left": "Ostávajúcich znakov",
			"monday": "Pondelok",
			"tuesday": "Utorok",
			"wednesday": "Streda",
			"thursday": "Štvrtok",
			"friday": "Piatok",
			"saturday": "Sobota",
			"sunday": "Nedeľa",
			"mon": "Po",
			"tue": "Ut",
			"wed": "St",
			"thu": "Št",
			"fri": "Pia",
			"sat": "So",
			"sun": "Ne",
			"yes": "Áno",
			"no": "Nie",
			"currency": "€",
			"filter": "Filtrovať",
			"calcel_filter": "Zrušiť filtrovanie",
			"name": "Názov",
			"confirm_delete": "Naozaj chcete túto šablónu zmazať?",
			"margin": "Odsadenie",
			"add_shape_button": "Nová vrstva",
			"add_shape": "Pridať novú vrstvu",
			"shape_list": "Zoznam vrstiev",
			"diameter": "Priemer",
			"active": "Aktívne",
			"active_from": "Aktívne od",
			"active_to": "Aktívne do",
			"inactive": "Neaktívne",
			"set_active_date": "Aktivita šablóny",
			"timer": "Časovač",
			"invalid_active_date_range": "Neplatný rozsah dátumov",
			"circle": "Kruh",
			"frame": "Rám",
			"rectangle": "Obdĺžnik",
			"triangle1": "Trojuhoľník",
			"triangle2": "Trojuhoľník",
			"triangle_side_length": "Dĺžka strany",
			"corner_radius": "Zaoblenie",
			"dynamicText": "Feed element",
			"imageFromElements": "Obrázok z elementu",
			"curvedText": "Text pozdĺž krivky",
			"circleText": "Text pozdĺž kruhu",
			"textWithElements": "Text s elementmi",
			"background_settings": "Nastavenie pozadia",
			"text_wrap": "Zalamovanie textu",
			"text_overflow": "Pretekania textu",
			"text_overflow_keep": "ponechať nezmenené",
			"text_overflow_fontsize": "zmenšiť písmo",
			"text_overflow_layersize": "zväčšiť vrstvu",
			"text_decoration": "Čiara",
			"text_decoration_color": "Farba čiary",
			"text_decoration_linethickness": "Hrúbka čiary",
			"text_decoration_lineoverlap": "Presah čiary",
			"text_decoration_none": "žiadna",
			"text_decoration_underline": "pod",
			"text_decoration_overline": "nad",
			"text_decoration_linethrough": "cez",
			"text_direction": "Smer textu",
			"text_align": "Zarovnanie textu",
			"text_align_left": "naľavo",
			"text_align_right": "napravo",
			"text_align_center": "centrovať",
			"text_valign": "Vertikálne zarovnanie",
			"text_valign_start": "hore",
			"text_valign_middle": "na stred",
			"text_valign_end": "dole",
			"height": "Výška",
			"aspect_size_ratio": "Zachovať pomer strán",
			"dash_length": "Dĺžka čiarkovania",
			"dash_density": "Medzera",
			"dashedFrame": "Čiarkovaný rám",
			"coordinate_x": "Súradnica x",
			"coordinate_y": "Súradnica y",
			"template_saved": "Šablóna uložená.",
			"upload_error_unsupported_type": "Nepodporovaný typ súboru",
			"upload_error_large_file": "Súbor je príliš veľký. Max. veľkosť je 1MB.",
			"upload_error_image_too_big": "Rozmery obrázku sú príliš veľké. Prosím zmenšite obrázok a skúste to znova.",
			"active_templates": "Aktívne šablóny",
			"type": "Typ",
			"file_too_big": "Súbor je príliš veľký",
			"file": "Súbor",
			"bitmap": "Obrázok",
			"polygon": "Polygon",
			"bezier": "Krivka",
			"line": "Čiara",
			"line_cap": "Zakončenie čiary",
			"line_join": "Napojenie čiary",
			"line_cap_round": "oblé",
			"line_cap_inherit": "-",
			"line_cap_butt": "plochou hranou",
			"line_cap_square": "štvorcové",
			"line_join_inherit": "-",
			"line_join_miter": "ostrý roh",
			"line_join_round": "oblé",
			"line_join_bevel": "skosený roh",
			"collage_layouts": "Koláže",
			"add_layout_button": "Vlastné",
			"save_as_new_collage": "Uložiť ako novú koláž",
			"preview_for_format": "Náhľad pre formát",
			"no_custom_sets": "Nemáte zatiaľ žiadne vlastné sady obrázkov",
			"custom_image_set_add": "Vytvoriť sadu obrázkov",
			"custom_image_set_remove": "Zrušiť sadu obrázkov",
			"custom_image_set_remove_image": "Vymazať obrázok zo sady",
			"custom_image_set_selected_image": "Vybraný obrázok",
			"custom_image_set_selected": "Obrázky zo sady",
			"custom_set_name": "Názov sady obrázkov",
			"custom_image_set_no_set_selected": "Vyberte sadu",
			"custom_image_set_no_images_yet": "V tejto sade nie sú zatiaľ žiadne obrázky.",
			"custom_image_set_no_image_selected": "Vyberte obrázok",
			"custom_image_set_uploaded": "Obrázok bol nahraný do sady",
			"custom_image_set_cannot_remove_is_used": "Obrázok je používaný v niektorej zo šablón! Nemožno zmazať",
			"custom_image_set_cannot_remove_success": "Obrázok bol zmazaný.",
			"custom_image_set_deleted_success": "Sada bola zmazaná",
			"custom_image_set_delete_set_is_used": "Nie je možné zmazať túto sadu, je použitá v šablónach.",
			"scale": "Pomer veľkosti",
			"adjust_size": "Prispôsobenie veľkosti produktu",
			"enlarge": "Prispôsobiť veľkosť obrázku",
			"no_enlarge_nor_crop": "žiadne prispôsobenie",
			"duplicate": "Duplikovať šablónu",
			"horizontal_flip": "Preklopiť horizontálne",
			"vertical_flip": "Preklopiť vertikálne",
			"flip": "Vertikálne",
			"flop": "Horizontálne",
			"rotation": "Pootočenie",
			"elements": "Názov elementu, z ktorého chcete vložiť obsah",
			"xml_element_name": "Názov elementu",
			"rating_xml_element": "Element s hodnotením",
			"rating_count_xml_element": "Element s počtom hodnotení",
			"rating_max_value": "Maximálna hodnota v elemente s hodnotením",
			"rating_hide_empty": "Iba ak sú dostupné všetky elementy z feedu",
			"rating_min_stars": "Zobrazovať hodnotenie od",
			"no_rating_yet": "Tento produkt zatiaľ nikto nehodnotil",
			"empty_element": "<ELEMENT JE PRÁZDNY>",
			"imagick_fonts": "Font",
			"imagick_fonts_family": "Filtrovať rodinu písiem",
			"imagick_fonts_style": "Štýl",
			"imagick_fonts_info": "Upozornenie: niektoré fonty pre dynamický text nie sú dostupné a teda sa nemusia zobrazovať rovnako, ako výsledný vygenerovaný obrázok. Pre ukážku textu vo vybranom fonte použite tlačidlo Náhľad.",
			"render_preview": "Náhľad",
			"rotate_right": "Pootočiť doprava",
			"rotate_left": "Pootočiť doľava",
			"image_enlargment": "Zväčšenie obrázkov",
			"format": "Formát",
			"first": "Prvý",
			"last": "Posledný",
			"previews": "Náhľady",
			"more_previews": "Ďalšie náhľady",
			"edit_template": "Upraviť šablónu",
			"no_templates_this_size": "Takéto šablóny zatiaľ nemáte",
			"all_templates": "Všetky šablóny",
			"reload_images": "Ďalšie náhľady",
			"show_unmodified": "Zobraziť neupravené",
			"show_modified": "Zobraziť upravené",
			"help": "Nápoveda",
			"manage_templates": "Spravovať šablóny",
			"inactive_templates": "Neaktívne šablóny",
			"show_template": "Zobraziť šablónu",
			"no_image": "Produkt nemá obrázok.",
			"active_templates_only": "Iba aktívne šablóny",
			"unmodified_images": "Neupravené obrázky",
			"allow_cache": "Povoliť cache",
			"no_products_in_query": "Výbery produktov pre túto šablónu neobsahujú produkty. Zobrazujeme náhodné produkty z XML feedu.",
			"size_format": "Rozmer",
			"add_new": "pridať nový",
			"new": "Nový",
			"format_name": "Názov formátu",
			"select_format": "Zvoľte jeden z výstupných formátov...",
			"query_is_required": "Musíte vybrať aspoň jeden výber produktu",
			"format_name_is_required": "Musíte vyplniť názov rozmeru",
			"width_is_required": "Šírka musí byť väčšia ako 0",
			"height_is_required": "Výška musí byť väčšia ako 0",
			"bad_file_format": "Nepovolený formát súboru",
			"name_is_required": "Musíte vyplniť názov šablóny",
			"error_loading_image": "Chyba pri načítaní obrázku",
			"confirm__bulk_delete": "Naozaj chcete zmazať vybrané šablóny?",
			"svg_change_colors": "Zmeniť farby",
			"apply_color_change": "Aplikovať zmenu farieb",
			"load_image_error": "Nepodarilo sa načítať obrázok",
			"badge": "Samolepka",
			"badges": "Samolepky",
			"icons": "Ikony",
			"search_badges_or_icons": "Hľadať grafické prvky alebo ikony",
			"tags": "Štítky",
			"emoji": "Emoji",
			"change": "Zmeniť",
			"summer": "Leto",
			"borders": "Rámčeky",
			"rating": "Hodnotenie",
			"rating_source": "Zdroj hodnotenia",
			"xml_element": "XML element",
			"depots_extension": "Rozšírenie Depots",
			"depots_not_enabled": "Pre využitie Depots ako zdroja hodnotenia do obrazkov ho aktivujte zadarmo v <span class=\"link\" onClick=Mergado.openWindow(\"https://store.mergado.com/detail/mergadodepots/#about\")>Mergado Store</span>.",
			"rating_from_element": "Hodnotenie produktov",
			"star_symbol": "Symbol hviezdy",
			"active_only": "Len aktívne",
			"dynamic_only": "Len dynamické",
			"autumn": "Jeseň",
			"showroom": "Náhľady šablón",
			"translate": "Posunutie",
			"crop": "Orezať obrázok",
			"image_format": "Veľkosť obrázku produktu",
			"enlarge_hint": "Veľkosť obrázku produktu sa upraví tak, aby vždy vyplnila požadovaný formát (pri zachování pomeru strán)",
			"crop_hint": "Ak je obrázok produktu väčší ako nastavený formát, systém ho automaticky oreže.",
			"winter": "Vianoce",
			"vertical_align_center": "Vycentrovať vertikálne",
			"horizontal_align_center": "Vycentrovať horizontálne",
			"enlarge_by": "Prispôsobenie veľkosti obrázku podľa",
			"by_width": "šírky obrázku",
			"by_height": "výšky obrázku",
			"by_smaller": "menšieho rozmeru obrázku",
			"by_bigger": "väčšieho rozmeru obrázku",
			"by_fit": "fit na rozmery výstupného formátu",
			"max_image_width": "Max šírka obrázku (px)",
			"max_image_height": "Max výška obrázku (px)",
			"by_max_size": "Nastaviť max veľkosť (px)",
			"by_overscan": "Nastaviť presah (px)",
			"overscan": "Ochranná zóna",
			"overscan_hint": "Tu si môžete nastaviť, o koľko pixelov sa má obrázok zmenšiť oproti veľkosti pôvodného formátu. Môžete tu nastaviť kladnú aj zápornú hodnotu. Kladnou hodnotou dosiahnete orámovanie pôvodného obrázku nastavenou podkladovou farbou, zápornou zväčšenie.",
			"enlarge_by_hint": "Tu si zvoľte, podľa akého rozmeru sa majú obrázky produktov prispôsobiť do veľkosti formátu. Pri všetkých zdrojových obrázkoch sa vždy zachováva pomer strán.",
			"enlarge_by_blog_link": "Podrobnejšie vysvetlenie",
			"error_save_template": "Pri ukladaní šablóny sa vyskytla chyba.",
			"free-delivery": "Dni dopravy zdarma",
			"black-friday": "BLACK FRIDAY   &   CYBER MONDAY",
			"valentine": "Valentín",
			"easter": "Veľká noc",
			"generic": "Univerzálne šablóny",
			"source_image": "Zdrojový obrázok",
			"sourceImage": "Zdrojový obrázok",
			"edit_shape": "Editácia vrstvy",
			"new_shape": "Nová vrstva",
			"modal_close": "Zavrieť",
			"done": "Hotovo",
			"general_error": "Chyba",
			"validation_error_fields.queries": "Neboli vybrané produkty.",
			"validation_error_fields.shapes": "Šablóna je prázdna.",
			"validation_error_queries": "Neboli vybrané produkty.",
			"validation_error_size.id": "Chýba formát výsledného obrázku.",
			"validation_error_name": "Chýba názov.",
			"validation_error_setName": "Chýba názov setu",
			"validation_error_visual_similarity_templateids": "Vyberte šablóny, v ktorých chcete hľadať podobné produkty.",
			"shape_name": "Názov vrstvy",
			"shape_badge_set_change": "Zmeniť set",
			"delete_shape": "Zmazať vrstvu",
			"edit_done": "OK",
			"loading": "Načítavam...",
			"low_contrast": "Nízky kontrast",
			"same_image_in_preview": "Rovnaký produkt v náhľade",
			"processed_at": "Dátum spracovania",
			"total_processed": "spracované",
			"with_status_ok": "bez chýb",
			"with_status_error": "chybných",
			"without_images": "bez obrázkov",
			"image_link": "Adresa obrázku",
			"content_length": "Veľkosť súboru",
			"probability": "Pravdepodobnosť",
			"showGroup": "Skupina",
			"user_set": "Nastavené užívateľom",
			"status_code": "kód stavu",
			"error": "chyba",
			"status_null": "?",
			"status_0_0": "V dobe spracovania nedostupný",
			"status_200_0": "V poriadku",
			"status_200_null": "V poriadku",
			"status_200_1": "Nulová veľkosť obrázku",
			"status_200_435": "Chýba šablóna",
			"status_200_425": "Too Early",
			"status_200_450": "Neznámy formát",
			"status_500_0": "Interná chyba servera",
			"status_503_0": "Služba je nedostupná",
			"status_400_0": "Chybná požiadavka",
			"status_404_0": "Stránka nenájdená",
			"status_404_null": "Stránka nenájdená",
			"status_403_0": "Prístup odmietnutý",
			"status_200_420": "Neznámy formát",
			"status_429_0": "Príliš veľa žiadostí",
			"status_200_465": "Výška alebo šírka obrázka presahuje limit",
			"status_too_many_alts": "Mnoho alternatívnych obrázkov",
			"status_same_images": "Produkty s rovnakými obrázkami",
			"status_empty_images": "Chýbajúce obrázky",
			"status_empty_images_description": "Vo vašom xml feede chýba u produktov element IMGURL. Produkty nie sú prepojené s obrázkami, alebo obrázkové súbory úplne chýbajú. Dôsledkom toho sa nebudú vo vašom e-shope ani v porovnávačoch zobrazovať.",
			"status_unavailable_description": "Webová stránka, kde sú obrázky uložené, nebola nájdená.",
			"status_unsupported_mime_type_description": "Formát súboru, na ktorý URL adresa odkazuje nepatrí medzi štandardné obrázkové formáty. Produktové obrázky sa nebudú zobrazovať.",
			"status_invalid_url_description": "Produktové obrázky môžu byť porovnávačmi zamietnuté, ak je ich URL adresa príliš dlhá alebo obsahuje znaky, ktoré nie sú podľa kritérií povolené. Častým problémom je diakritika alebo medzery v názve obrázkov.",
			"has_watermark_description": "Ak chránite svoje produktové obrázky vodoznakmi, počítajte s tým, že reklamné systémy ako Heureka, GLAMI, FAVI či Google Nákupy vám tieto produkty nezobrazia.",
			"status_wrong_placement_description": "V ideálnom prípade by mali produkty na obrázku vypĺňať čo najväčšiu plochu a byť zarovnané na stred. V opačnom prípade sa u nich stráca informačná hodnota a pôsobia nejednotne. ",
			"status_poor_quality_images_description": "Ak produktové obrázky nie sú dostatočne ostré, obsahujú glitch alebo sú iným spôsobom rozmazané, môžu svojou kvalitou odradiť zákazníkov. ",
			"status_seo_large_file_description": "<h3>Popis odporúčania:</h3> Veľkosť obrázkov presahuje hranicu 400 kB. Vo vašom e-shope sa to negatívne prejaví tak, že sa obrázky budú dlho načítať, čo môže viesť k zvýšenej miere opustenosti. <br/><h3>Detail riešenia:</h3> Feed Image Editor hromadne skomprimuje príliš veľké obrázky a zníži tak ich veľkosť aby sa rýchlejšie načítavali na webe. Viac sa dočítate v článku na <span class=\"link\" onClick=Mergado.openWindow(\"https://www.feed-image-editor.sk/zlepsite-seo-obrazkov-pomocou-automatickej-kompresie\")>našom blogu</span>.",
			"status_few_alt_images_description": "<h3>Detailný popis problému:</h3> Porovnávače, na ktorých chcete inzerovať, umožňujú k produktom zobrazovať alternatívne obrázky. K nasledujúcim produktom pritom nemáte dostupný ani jeden alternatívny obrázok.<br/><h3>Riešenie:</h3> Doplňte do feedu alternatívne obrázky a využite možnosti porovnávačov na maximum. Ako k produktom vyhľadať obrázky sa dozviete v článku na našom blogu.",
			"status_transparent_background_description": "Biele pozadie produktových obrázkov je nepísaným štandardom u väčšiny reklamných systémov a porovnávačov. V prípade, že niektoré z vašich obrázkov majú priehľadné pozadie, budú zamietnuté alebo sa im pozadie doplní automaticky a budú vyzerať kostrbato.",
			"status_same_images_description": "Niektoré produkty majú rovnaké obrázky, napríklad pri veľkostných variantoch oblečenia, pri ilustračných obrázkoch autosúčiastok či nehmotných produktoch. V iných prípadoch to nerobí dobrý dojem.",
			"alternative_images_description": "Vaše produkty majú viac alternatívnych obrázkov, než je povolené porovnávačom. Tieto obrázky, ktoré sú naviac sa v porovnávači nezobrazia. Zohľadnite to a inzerujte tie najatraktívnejšie alternatívne obrázky.",
			"status_poor_quality_images": "Kvalita obrázku",
			"status_seo_large_file": "Veľkosť súboru s obrázkom z hľadiska SEO",
			"status_few_alt_images": "Možnosť doplniť alternatívne obrázky",
			"status_all": "Všetky produkty",
			"status_unavailable": "Nedostupné obrázky",
			"status_invalid_url": "Neplatná URL adresa",
			"status_unsupported_mime_type": "Nepodporovaný formát",
			"status_wrong_placement": "Pozícia, zarovnanie a veľkosť produktu na obrázku",
			"status_transparent_background": "Priehľadné pozadie",
			"unsupported_mime_by_engines": "Obrázky nepodporované inzertným kanálom: Formát súboru, ktorý ste zvolili pre export obrázkov, nie je podporovaný porovnávačom, na ktorom chcete inzerovať. Výstupný formát zmeníte v nastaveniach.",
			"supports_formats": "podporuje formáty",
			"with_problems": "s chybami",
			"clear_old_products": "Zmazať staré produkty v db",
			"info_is_new": "Zatiaľ žiadne importované produkty. Zdá sa, že na tomto projekte ešte neprebehli pravidlá.",
			"info_no_data": "Nastaveným filtrom nezodpovedajú žiadne produkty.",
			"info_not_processed_yet": "Spracovanie a diagnostika prebieha priebežne počas dňa.",
			"info_apply_one_rule": "V prípade, že máte pre rovnaké produkty viac šablón, aplikuje sa iba šablóna s najvyššou prioritou. Výber produktov pre jednotlivé šablóny môžete zvoliť pri editácii šablóny v záložke produkty.",
			"filter_image_url": "Adresa obrázka",
			"filter_product_url": "Adresa produktu",
			"filter_product_urls": "Adresy produktov",
			"fulltext": "Fulltextové vyhľadávanie",
			"input_list": "Zadajte viac adries oddelených čiarkou alebo koncom riadku",
			"more": "Viac",
			"less": "Menej",
			"filter_status_code": "Stavový kód",
			"filter_template": "Šablóna",
			"filter_from": "Dátum od",
			"filter_to": "Dátum do",
			"filter_productname": "Názov produktu",
			"filter_productid": "MERGADO id produktu",
			"filter_element": "Element",
			"filter_element_value": "Hodnota elementu",
			"filter_value_from": "Od",
			"filter_value_to": "Do",
			"filter_add": "Element",
			"filter_remove": "Zrušiť <br/>všetky filtre",
			"filter_group": "Skupina",
			"filter_content_type": "Formát obrázku",
			"filter_content_length": "Veľkosť",
			"custom_filter": "Vlastný filter",
			"preset_ranges": "Predvolené rozsahy",
			"filter_mistake_set_by_user": "Stav nastavený užívateľom",
			"filter_correctness_percentage_offset": "Vzdialenosť od okraja",
			"filter_has_alpha": "Priehľadné pozadie",
			"filter_status_reason": "Dôvod stavu",
			"filter_status": "Stav",
			"filter_probability": "Pravdepodobnosť výskytu vodoznaku [%]",
			"filter_user_set_watermark": "Vodoznak v obrázku (užívateľ)",
			"filter_user_set": "Stav nastavený užívateľom",
			"watermarks": "Vodoznaky",
			"images_quality": "Kvalita obrázkov",
			"quality_status": "Stav kvality",
			"bad_quality_score": "Skóre zlej kvality",
			"good_quality": "Dobrá",
			"bad_quality": "Zlá",
			"middle_quality": "Stredná",
			"diagnostics": "Diagnostika",
			"processed_alt_images": "Spracovávaných alternatívnych obrázkov",
			"processed_images": "Spracovávaných obrázkov",
			"problems": "Problémy",
			"warnings": "Upozornenie",
			"recommendations": "Odporúčanie",
			"overview": "Prehľad",
			"watermarks_removal": "Odstránenie vodoznakov",
			"selected_watermark_pattern": "Tento obrázok bude použitý ako vzor hľadaného vodoznaku",
			"select_watermark_pattern": "Pridať do vzorov obsahujúce vodoznak",
			"user_set_objects": "Užívateľom označené pozície vodoznakov",
			"with_or_without_objects": "Označené vodoznaky",
			"with_objects": "S označenými vodoznakmi",
			"without_objects": "Bez označených vodoznakov",
			"all": "Všetky",
			"view_mode": "Zobrazenie",
			"problems_text": "U toľkých produktov sa <b>nezobrazujú produktové obrázky</b>, pretože sa vyskytol minimálne jeden z týchto problémov:",
			"warnings_text": "U toľkých produktov sú <b>limity v zobrazovaní vašich obrázkov</b>, pretože sa vyskytlo minimálne jedno z týchto varovaní:",
			"recommendations_text": "U toľkých produktov sa <b>nezobrazujú produktové obrázky</b>, pretože sa vyskytol minimálne jeden z týchto problémov:",
			"one_product": "produkt",
			"less_than_five_products": "produkty",
			"products_count": "produktov",
			"image_id": "ID obrázku",
			"mistake_set_by_user": "Chyba nastavená uživatelem",
			"correctness_percentage_offset": "Vzdialenosť od okraja",
			"has_alpha": "Priehľadnosť",
			"status_reason": "Dôvod stavu",
			"status": "Stav",
			"updated_at": "Aktualizované",
			"no_alpha": "Nie",
			"with_alpha": "Áno",
			"info_status_suspicious": "Nie je možné rozpoznať či je obrázok zámerne takto umiestnený",
			"vertical_image": "Vertikálny obrázok",
			"horizontal_image": "Horizontálny obrázok",
			"image_down": "Obrázok dole",
			"image_up": "Obrázok hore",
			"image_right": "Obrázok napravo",
			"image_left": "Obrázok naľavo",
			"image_in_the_middle": "Obrázok uprostred",
			"image_could_not_be_read": "Obrázok nemožno prečítať",
			"unknown_image_format": "Neznámy formát",
			"option_false": "Nie",
			"option_true": "Áno",
			"option_not_set": "Hodnota nenastavená",
			"mistake_by_user_successfully_changed": "Hodnota zmenená",
			"status_N/A": "Podozrivý",
			"status_ERROR": "Chyba",
			"status_OK": "V poriadku",
			"status_NOT_OK": "Nie je v poriadku",
			"status_NOT_DETECTED": "Nezistený",
			"importance_HIGH": "Vysoká",
			"importance_MEDIUM": "Stredná",
			"importance_SMALL": "Nízka",
			"filter_is_active": "Fiter je aktívny",
			"export_to_csv": "Exportovať",
			"csv_download_started": "Vytváram csv, prosím čakajte",
			"csv_download_success": "Súbor bol vytvorený",
			"csv_download_error": "Došlo k chybe pri exporte do csv",
			"shop_link": "Odkaz do e-shopu",
			"unmodified_link": "Neupravený obrázok",
			"modified_link": "Obrázok cez šablónu",
			"total_products": "Produktov",
			"total_images": "Obrázkov",
			"total_alt_images": "Alternatívnych obrázkov",
			"total_products_info": "Celkom produktov importovaných z MERGADA",
			"no_products_yet": "Zatiaľ žiadne importované produkty k tejto šablóne.",
			"total_processed_products_info": "Celkom pred-spracovaných produktov",
			"product": "Produkt",
			"product_category": "Kategória",
			"product_links": "Odkazy",
			"eshop_product": "Produkt v E-shope",
			"barcode_lookup": "Produkt v BarcodeLookup",
			"product_name": "Produkt",
			"product_no": "Číslo produktu",
			"product_code": "Kód produktu",
			"product_image": "Obrázok",
			"product_template": "Šablóna",
			"product_image_link": "Adresa obrázku",
			"element_item_id": "ID produktu",
			"element_url": "Adresa do E-shopu",
			"element_cpc": "CPC",
			"element_name": "Názov produktu",
			"element_img_url": "Adresa výstupného obrázku",
			"element_img_url_input": "Adresa vstupného obrázku",
			"element_alt_img_url": "Adresa výstupného alternatívneho obrázku",
			"element_alt_img_url_input": "Adresa vstupného alternatívneho obrázku",
			"element_price_vat": "Cena s DPH",
			"element_delivery_date": "DELIVERY_DATE",
			"element_manufacturer": "Výrobca",
			"element_categorytext": "Kategória",
			"element_ean": "EAN",
			"element_productno": "Číslo produktu",
			"element_accessory": "Príslušenstvo",
			"element_gift": "Darček",
			"element_itemgroup_id": "ITEMGROUP_ID",
			"advanced_search": "Rozšírené vyhľadávanie",
			"export_is_ready": "Export je pripravený.",
			"download": "Stiahnuť",
			"please_wait_generating_export": "Prosím čakajte, generujem export",
			"please_wait_generating_export2": "Toto okno môžete zavrieť. V okamžiku, kedy bude export pripravený, zobrazí se vám notifikácia s odkazom k stiahnutiu. ",
			"click_to_download_export": "Stiahnutie exportu vykonáte kliknutím na tlačítko Stiahnuť",
			"exported": "Exportované",
			"close": "Zatvoriť",
			"n_products": "Produktov",
			"template_exported": "Šablóna bola exportovaná",
			"export_template": "Exportovať šablónu",
			"import_template": "Importovať šablónu",
			"link_image_url": "Adresa obrázku",
			"link_fie": "Obrázok z Feed Image Editora",
			"link_mergado": "Produkt v MERGADE",
			"link_eshop": "Produkt v E-shope",
			"template_not_found": "Šablóna nenájdená!",
			"template_preview": "Náhľad",
			"template_is_dynamic": "Šablóna s dynamickými prvkami",
			"input_width": "Šírka vstup. obrázka",
			"input_height": "Výška vstup. obrázka",
			"product_content_type": "Formát obrázku",
			"product_content_length": "vstupná veľkosť [kB]",
			"rendered_content_length": "výstupná veľkosť [kB]",
			"copy_to_clipboard": "Skopírovať do schránky",
			"copy_mergado_query": "Skopírovať dotaz pre MERGADO do schránky",
			"copied_to_clipboard": "skopírované",
			"products_per_page": "Počet produktov na stránke náhľady",
			"layer_copied": "Vrstva bola skopírovaná do schránky",
			"ask_save_before_leave": "Ak odídete, vaše zmeny nemusia byť uložené.",
			"ask_save_before_leave_title": "Odísť bez uloženia?",
			"ask_save_before_leave_leave": "Odísť",
			"ask_save_before_leave_stay": "Zostať",
			"history_undo": "Späť",
			"history_redo": "Znovu",
			"history_initial": "Vrátiť všetko",
			"settings": "Nastavenie",
			"confirm_delete_format": "Naozaj zmazať formát",
			"confirm_delete_format_yes": "Áno",
			"confirm_delete_format_no": "Nie",
			"templates_having_this_size": "Šablóny s týmto formátom",
			"project_settings": "Nastavenie projektu",
			"ui_settings": "Nastavenia užívateľského rozhrania",
			"output_image_format": "Nastavenie výstupného formátu",
			"output_image_compression": "Kompresia výstupného obrázku",
			"auto_compression_to_size": "Automatická kompresia do veľkosti",
			"group_by_image": "Zoskupovať podľa obrázku",
			"products_per_page_on_list": "Produktov na stránke",
			"ask_before_leave": "Pred ukončením editora sa pýtať na uloženie zmien",
			"settings_value": "hodnota",
			"settings_update_success": "Nastavenie uložené",
			"settings_update_error": "Nastala chyba pri ukladaní nastavení",
			"save_sizes_success": "Formát uložený",
			"save_sizes_error": "Nastala chyba pri ukladaní formátu",
			"different_hash": "Údaje nemusia byť aktuálne",
			"filtered_items": "Vyfiltrované",
			"set_template_active_date_success": "Dátum bolo nastavené",
			"set_template_active_date_error": "Nepodarilo sa nastaviť dátum",
			"from_date": "od",
			"to_date": "do",
			"is_active": "je aktívny",
			"not_active": "nie je aktívny",
			"is_date_limited": "Aktívny od - do",
			"active_now": "Aktívna hneď",
			"set_timer": "Načasovať spustenie",
			"show_more": "Viac...",
			"show_less": "Menej...",
			"output_image_preview": "Náhľad výstupného obrázku",
			"output_image_content_length": "Veľkosť",
			"original_output_image_content_length": "Pôvodné",
			"less_than_original": "menej ako pôvodne",
			"more_than_original": "viac než pôvodne",
			"about": "o",
			"has_no_watermark": "Neobsahuje vodoznak",
			"has_watermark": "Obsahuje vodoznak",
			"watermark_status": "Vodoznak v obrázku",
			"hiding_products": "Skrývanie výrobkov",
			"hide_products_by_filter": "Skryť produkty podľa filtra",
			"unhide_products": "Odkryť",
			"hidden_by_filter": "Skryté podľa filtra",
			"hide_by_has_watermark": "Skryť produkty s vodoznaky",
			"hide_by_wrong_placement": "Skryť produkty so zlým umiestnením obrázku",
			"hide_by_low_quality": "Skryť produkty s nízkou kvalitou",
			"hide_by_seo_large_file": "Skryť produkty s veľkým obrázkom z hľadiska SEO",
			"filter_content_length_gt": "Veľkosť väčšiu ako ... [kB]",
			"filter_content_length_lt": "Veľkosť menšiu ako ... [kB]",
			"set_by_user": "Nastavené užívateľom",
			"filter_empty_content": "Prázdny obsah obrázku",
			"filter_no_image": "Bez obrázku",
			"is_collage": "Rozloženie",
			"all_available_only": "Iba ak sú dostupné všetky alternatívne obrázky",
			"single_image": "Jeden produktový obrázok",
			"collage_layout": "Vyberte rozloženie",
			"export_layouts": "Exportovať rozloženia",
			"import_layouts": "Importovať rozloženia",
			"export_gradients": "Exportovať gradienty",
			"import_gradients": "Importovať gradienty",
			"main_image": "Obrázok",
			"alt_image": "Alt",
			"alternative_images": "Alternatívne obrázky",
			"save_layouts_error": "Došlo ku chybe pri ukladaní",
			"save_layouts_success": "Uložené",
			"delete_layouts_error": "Pri odstraňovaní rozloženia sa vyskytla chyba. Rozloženie je používané v šablóne.",
			"delete_layout_image_error": "Chyba pri mazaní obrázku z rozloženia",
			"delete_layouts_success": "Vymazané",
			"add_layout_image_success": "Obrázok pridaný do rozloženia",
			"add_layout_image_error": "Došlo k chybe pri pridávaní obrázku rozložení",
			"create_default_layouts": "Znovu vytvoriť predvolenú sadu rozloženie",
			"create_default_layouts_success": "Predvolené rozloženie úspešne vytvorené",
			"create_default_layouts_error": "Chyba pri vytváraní predvoleného rozložení",
			"delete_all_unused": "Zmazať všetky nepoužívané",
			"delete_all_unused_success": "Úspešne zmazané",
			"delete_all_unused_error": "Chyba pri mazaní",
			"layout_name": "Názov rozloženie",
			"selected_layout_image": "Vybraný obrázok",
			"add_layout": "Pridať rozloženie",
			"delete_layout": "Zmazať rozloženie",
			"delete_layout_image": "Odstrániť obrázok rozloženia",
			"add_layout_image": "Pridajte obrázok rozloženia",
			"save_all_layouts": "Uložiť všetky rozloženie",
			"save_layout": "Uložiť rozloženie",
			"padding_px": "Odsadenie obrázku [px]",
			"assigned_image": "Priradený obrázok",
			"units": "Jednotky",
			"layout_pos": "Umiestnenie",
			"layout_size": "Rozmery",
			"add_layout_success": "Nové rozloženie pridané",
			"add_layout_error": "Došlo ku chybe pri pridávaní rozložení",
			"template_sizes": "Rozmery výstupného obrázku",
			"save_order": "Uložiť poradí",
			"save_settings_order_success": "Poradie nástavný uložené",
			"save_settings_order_error": "Chyba pri ukladaní poradí",
			"import_template_success": "Šablóna bola importovaná",
			"import_template_error": "Pri importovaní šablóny sa vyskytla chyba",
			"representative_colors": "Reprezentatívne farby z obrázku",
			"shortcuts": "Klávesové skratky",
			"shortcut_ins": "Vložiť novú vrstvu",
			"shortcut_del": "Zmazať vrstvu",
			"shortcut_save": "Uložiť šablónu",
			"shortcut_undo": "Editácia späť",
			"shortcut_redo": "Editácia znova",
			"shortcut_copy": "Kopírovať vrstvu",
			"shortcut_paste": "Vložiť vrstvu",
			"product_is_rendering": "Generujem náhľad",
			"product_is_loading": "Načítavam produkt",
			"is_saving": "Ukladám",
			"invalid_filed_value": "Neplatná hodnota poľa",
			"value_not_set": "nenastavené",
			"font_not_found": "Font nebol nájdený. Nahradený defaultným.",
			"radius": "Polomer",
			"gradient_type_linear": "Lineárny",
			"gradient_type_radial": "Radiálny",
			"no_gradient": "Žiadny gradient",
			"select_gradient": "Vybrať gradient",
			"select_gradients": "Vyberte gradienty",
			"save_as_new_gradient": "Uložiť ako nový gradient",
			"info_gradients_not_saved": "Zmeny v gradientu ešte nie sú uložené",
			"gradient": "Gradient",
			"gradients": "Gradienty",
			"confirm_remove_gradient": "Zmazať tento gradient?",
			"palettes": "Palety farieb",
			"predefined_colors": "Preddefinované farby",
			"brand_colors": "Farby brandu",
			"custom_colors": "Vlastné palety farieb",
			"select_palette": "Vybrať paletu",
			"extract_colors_from_image": "Extrahovať farby z obrázku",
			"add_to_custom_palettes": "Pridať k vlastným paletám",
			"save_custom_colors": "Uložiť vlastné farby",
			"save_as_default": "Uložiť ako predvolený",
			"saved": "Uložené",
			"no_changes": "Žiadne zmeny",
			"no_custom_palettes": "Zatiaľ nemáte žiadne vlastné palety",
			"create_layer_group": "Vytvoriť skupinu vrstiev",
			"group": "Zoskupiť",
			"ungroup": "Oddeliť",
			"delete_layer_group": "Zrušiť skupinu vrstiev",
			"toggle_visibility": "Prepnúť viditeľnosť",
			"delete_layers": "Odstrániť vrstvy",
			"delete_layer": "Odstrániť vrstvu",
			"duplicate_layer": "Duplikovať vrstvu",
			"duplicate_layers": "Duplikovať vrstvy",
			"edit_layer": "Upraviť vrstvu",
			"lock_layer": "Zamknúť vrstvu",
			"unlock_layer": "Odomknúť vrstvu",
			"thickness": "Hrúbka",
			"brightness": "Jas",
			"contrast": "Kontrast",
			"show_products": "Zobraziť produkty",
			"reset_effects": "Zrušiť efekty",
			"auto_level": "Automatické vyváženie farieb",
			"alpha": "Priehľadnosť",
			"save_as_query": "Uložiť ako<br/> výber",
			"save_as_query_title": "Uložiť ako výber",
			"fie_query_type": "Typ",
			"fie_query_name": "Názov výberu",
			"fie_query_element": "Názov nového elementu v MERGADE",
			"fie_query_filter": "Produktový filter",
			"fie_query_is_active": "Aktívny",
			"query_in_use": "Tento výber je používaný v šablóne",
			"fie_queries": "Výbery",
			"fie_queries_info": "Výběry - TODO: napověda",
			"no_fie_queries_yet": "Zatiaľ nemáte žiadne výbery produktov. Môžete ich vytvorit v sekcii produkty.",
			"toggle_active": "Prepnúť aktívny / neaktívny",
			"set_active": "Prepnúť aktívny",
			"set_inactive": "Prepnúť neaktívny",
			"image": "Obrázok",
			"mergado_connection_verifying": "Overujem spojenie s MERGADEM",
			"show_in_mergado": "Ukázať v MERGADU",
			"mergado_queries": "Výbery",
			"mergado_products": "Produkty",
			"mergado_formats": "Formáty",
			"mergado_elements": "Elementy",
			"output_image_element": "Výstupný obrázkový element",
			"output_image_hidden_warning": "Pozor, výstupný obrázkový element pre tento typ exportu je skrytý",
			"not_empty_error": "Toto pole je povinné",
			"drop_shadow": "Tieň",
			"shadow_color": "Farba tieňa",
			"shadow_opacity": "Priehľadnosť",
			"shadow_sigma": "Rozmazanie",
			"shadow_offset": "Posunutie",
			"shadow_xoffset": "X",
			"shadow_yoffset": "Y",
			"effect_sensitivity": "Citlivosť efektu",
			"sensitivity": "citlivosť",
			"LOW": "nízka",
			"MEDIUM": "stredná",
			"HIGH": "vysoká",
			"too_big_for_upscale": "Obrázok je väčší ako 600 x 600 pixelov, vylepšenie rozlíšenia nie je možné aplikovať. Skúste prosím načítať iný náhodný obrázok.",
			"only_main_image": "iba hlavný obrázok",
			"other_effects": "Ďalšie efekty",
			"flood_fill_points": "Body",
			"fuzz": "Rozptyl",
			"heureka_175x175": "Heureka – doporučené rozmery",
			"heureka_4096x4096": "Heureka – maximálne rozmery",
			"zoot_1000x745": "Zoot – minimálne rozmery",
			"zoot_1907x2562": "Zoot – doporučené rozmery",
			"zbozi_425x440": "Zboží.cz – minimálne rozmery",
			"zbozi_600x800": "Zboží.cz – minimálne rozmery (bazárový tovar)",
			"google_100x100": "Google Merchants – minimálne rozmery",
			"google_250x250": "Google Merchants – minimálne rozmery u oblečenia",
			"google_500x500": "Google Merchants – minimálne rozmery *od 31. 1. 2027",
			"google_1500x1500": "Google Merchants – doporučené rozmery",
			"glami_400x400": "GLAMI – minimálne rozmery",
			"glami_1500x1500": "GLAMI – doporučené rozmery",
			"alza_600x600": "ALZA – minimálne rozmery",
			"alza_1000x1000": "ALZA – minimálne doporučené rozmery",
			"alza_1300x1300": "ALZA – maximálne doporučené rozmery",
			"favi_600x600": "FAVI – minimálne rozmery",
			"favi_1000x1000": "FAVI – doporučené rozmery",
			"biano_400x400": "BIANO – minimálne rozmery",
			"biano_1500x1500": "BIANO – doporučené rozmery",
			"shopalike_250x250": "Shopalike – minimálne rozmery",
			"shopalike_1024x1024": "Shopalike – doporučené rozmery",
			"instagram_1024x1024": "Instagram – doporučené rozmery",
			"instagram_1080x1080": "Instagram",
			"instagram_1080x1350": "Instagram",
			"instagram_1080x566": "Instagram",
			"instagram_1080x1920": "Instagram",
			"instagram_1440x1800": "Instagram",
			"instagram_1440x2560": "Instagram",
			"allegro_500x500": "Allegro – minimálne rozmery",
			"allegro_2560x2560": "Allegro – maximálne rozmery",
			"facebook_1024x1024": "Facebook – doporučené rozmery",
			"facebook_500x500": "Facebook – minimálne rozmery",
			"facebook_600x600": "Facebook",
			"facebook_1080x1080": "Facebook",
			"facebook_1200x1200": "Facebook",
			"facebook_1080x1350": "Facebook",
			"facebook_1200x628": "Facebook",
			"facebook_1440x1440": "Facebook",
			"facebook_1440x1800": "Facebook",
			"facebook_1440x2560": "Facebook",
			"modio_500x500": "Modio – minimálne rozmery",
			"modio_1024x1024": "Modio – doporučené rozmery",
			"modio_2048x2048": "Modio – maximálne rozmery",
			"mall_1280x1024": "Mall – minimálne rozmery",
			"mall_2000x2000": "Mall – maximálne rozmery",
			"kaufland_1024x1024": "Kaufland – minimálne rozmery",
			"kaufland_2048x2048": "Kaufland – doporučené rozmery",
			"snapchat_200x200": "Snapchat – minimálne rozmery",
			"pinterest_200x300": "Pinterest – minimálne rozmery",
			"pinterest_600x900": "Pinterest – minimálne rozmery",
			"pinterest_1000x1500": "Pinterest – doporučené rozmery",
			"pinterest_1080x1920": "Pinterest – doporučené rozmery",
			"pinterest_1080x1080": "Pinterest",
			"find_format": "Nájsť formát",
			"custom_formats": "Vlastné formáty",
			"other_formats": "Ďalšie formáty",
			"elements_availability": "Dostupnosť elementov v dynamických šablónach",
			"product_elements": "Elementy",
			"filter_missing_elements": "Filtrovať chýbajúce alebo prázdne elementy",
			"only_updated_products": "Iba produkty ktoré prešli pravidlami po uložení šablóny",
			"ok": "OK",
			"empty_elements": "Prázdne elementy",
			"toggle_snap_to_guides": "Prichytávať",
			"toggle_snap_to_grid": "Prichytávať k mriežke",
			"toggle_snap_to_element": "Prichytávať k prvku",
			"show_grid": "Mriežka",
			"snap_strength": "Pevnosť pri uchopení",
			"is_anim_gif": "Animovaný GIF",
			"outpainting": "Outpainting",
			"frames_delay": "Oneskorenie medzi snímkami [ms]",
			"loops_delay": "Oneskorenie na konci slučky [ms]",
			"info_no_active_template": "Aktuálne nemáte aktívnu ani jednu šablónu. Feed Image Editor začne pracovať v momente, keď nejakú z nich aktivujete.",
			"info_no_template": "<b>Nemáte vytvorenú žiadnu šablónu.</b><br/>Vyberte si jednu z predchystaných šablón z galérie alebo si vytvorte vlastnú.",
			"info_workshop": "Naučte sa využívať Feed Image Editor na sto percent. Prihláste sa na školenie o image marketingu, ktoré pre vás organizujeme zdarma. <span class=\"link\" onClick=Mergado.openWindow(\"https://www.feed-image-editor.sk/skolenie\")>Zistite viac</span>.",
			"replace_color": "Nahradenie farieb",
			"target_color": "Nahradiť farbu",
			"replace_by_color": "Farbou",
			"add_point": "Pridať bod",
			"info_no_points": "Body môžete pridat kliknutím na plátno",
			"projects_overview": "Prehľad projektov",
			"system": "System",
			"project_info": "Projekt",
			"templates": "Šablóny",
			"random_images": "Náhodné obrázky",
			"rules": "Pravidlá",
			"queries": "Výbery",
			"rabbit": "RabbitMQ",
			"points_coordinates": "Relatívna pozícia bodov",
			"no_images_found": "Nenašli sa žiadne produkty obsahujúce obrázky",
			"show_helper": "Zobraziť pomocníka",
			"disable_helper": "Nezobrazovať pomocníka",
			"disable_wheelzoom": "Zakázať zoom kolieskom myši",
			"helper_ok": "V poriadku",
			"helper_close": "Už viac nezobrazovať",
			"helper": "Pomocník",
			"need_help_title": "Potrebujete s niečím poradiť?",
			"need_help_text": "V prípade akýchkoľvek podnetov či problémov obráťte sa prosím našu podporu <a href=\"mailto:support@feedimageeditor.com\" class=\"mail-link\">support@feedimageeditor.com</a>.",
			"bezier_no_points": "<ul><li class=\"right-arrow-marker\">Nový bod krivky pridáte kliknutím na plátno</li></ul>",
			"bezier_add_points": "<ul><li class=\"right-arrow-marker\">Kliknite na plátno, podržte tlačidlo stlačené a nastavte kontrolné body ťahaním myši. Potom uvoľnite tlačidlo a môžete nastaviť ďalšie body.</li></ul>",
			"bezier_unselect": "<ul><li>Ak chcete zmeniť aktívny vrst, môžete použiť pravé tlačidlo myši alebo sa prepnúť v zozname vrstiev.</li></ul>",
			"has_reflection": "Odraz",
			"angle": "Uhol",
			"reflection_offset": "Offset",
			"reflection_opacity": "Priehľadnosť",
			"reflection_flip": "Prevrátiť",
			"helper_no_queries": "<ul><li class=\"info-marker\">Zvoľte produktový výber, na ktorý sa bude šablóna aplikovať. Na vyhľadanie výberu použite filter.</li></ul>",
			"helper_one_query": "<ul><li>Zvoliť môžete viacero výberov.</li></ul>",
			"helper_at_least_one_query": "<ul><li>Zvolené výbery nájdete vždy navrchu zoznamu.</li></ul>",
			"helper_zero_products_query": "<ul><li class=\"exclamation-marker\">Zvolený výber neobsahuje žiadne produkty.</li></ul>",
			"helper_no_format": "<ul><li class=\"info-marker\">Zvoľte jeden z prednastavených výstupných formátov. Vlastný formát si vytvoríte na konci zoznamu alebo v Nastaveniach.</li></ul>",
			"helper_format_selected": "<ul><li>Zvoľte jednu z možností prispôsobenia obrázkov.</li><li>Šírku presahu upravte ručne podľa potreby.</li></ul>",
			"helper_no_layer": "<ul><li class=\"info-marker\">Kliknutím na Nová vrstva pridáte do obrázkov text, štítky, grafiku a ďalšie prvky.</li></ul>",
			"helper_at_least_one_layer": "<ul><li>Poradie vrstiev zmeníte {ArrowVIcon} presunutím.</li><li>Vrstvy s elementami majú pevné poradie na vrchu plátna.</li><li>Nezabudnite si šablónu pomenovať a uložiť.</li></ul>",
			"helper_two_more_layers": "<ul><li>Podržte <span class=\"framed\">CTRL</span> a kurzorom označte viacero vrstiev. Tlačidlom {GroupIcon} ich zoskupíte do jednej vrstvy. Tým istým tlačidlom vrstvy naspäť rozdelíte.</li><li>Vodiace linky vám uľahčia zarovnávanie vrstiev. Aktivujete a deaktivujete ich tlačidlom {MagnetIcon}</li></ul>",
			"layers": "Vrstvy",
			"brush_spacing": "Rozstup",
			"brush_color": "Farba štetca",
			"brush_pattern": "Vzor",
			"brush_pattern_color": "Farba vzoru",
			"brush_rotate_pattern": "Natáčať vzor",
			"linewidth_profile": "Profil šírky čiary",
			"uniform": "rovnomerný",
			"fade_out": "postupne zoslabiť",
			"fade_in": "postupne zosilniť",
			"fading": "na koncoch zoslabiť",
			"zoom_in": "priblížiť",
			"zoom_out": "oddialiť",
			"token_not_provided": "Chyba overenia - token nebol poskytnutý",
			"toast_online_call": "Neviete si rady, alebo potrebujete pomôcť s vytvorením prvej obrazovej kampane? Dohodnite si <span class=\"link\" onClick=Mergado.openWindow(\"https://calendly.com/feed-image-editor\")>online call s Marekom</span>, ktorý vám poradí, ako využiť Feed Image Editor na maximum.",
			"online_call_header": "Chcete pomoc s nastavením alebo inšpiráciu pre vaše kampane?",
			"online_call": "Rezervujte si krátku bezplatnú konzultáciu s Marekom. Ukáže vám najlepšie postupy pre váš typ e-shopu, pomôže s nastavením a zodpovie všetko, čo vás zaujíma.",
			"watermark_mask": "Maska vodoznaku",
			"watermark_masked_image": "Vodoznak",
			"watermark_group": "Skupina vodoznakov",
			"watermark_groups": "Skupiny vodoznakov",
			"watermark_methods": "Metódy odstránenia vodoznakov",
			"create_new_group": "Vytvoriť novú skupinu",
			"new_group": "Nová skupina",
			"required_field": "Požadované pole",
			"no_watermark_masks": "Zatiaľ nemáte označené žiadne vodoznaky",
			"downloaded": "Stiahnuté",
			"status_ok": "Stav v poriadku",
			"waiting_to_process": "Čaká na spracovanie",
			"inpaint_error": "Chyba odstaranění vodoznaku",
			"watermark_group_not_selected": "Najskôr vyberte skupinu vodoznakov",
			"background": "Pozadie",
			"remove_background": "Odstrániť pozadie",
			"solid_bg": "Jednofarebné",
			"light_bg": "Svetlé pozadie",
			"dark_bg": "Tmavé pozadie",
			"background_colors": "Farby",
			"background_shade": "Odtieň pozadia",
			"not_transparent_bg": "Nie priehľadné pozadie",
			"transparent_bg": "Priehľadné pozadie",
			"multicolor_bg": "Viacfarebné",
			"status_not_recommended_colorspace": "Farebné modely",
			"not_recommended_colorspace": "Farebné modely",
			"not_recommended_colorspace_description": "Vaše obrázky sú vo farebnom modely CMYK, ktorý nie je vhodný  pre zobrazovanie na obrazovkách počítačov alebo mobilných zariadení. Takéto obrázky odradia vašich zákazníkov. Prekonvertujte obrázky do farebného modelu RGB.",
			"status_unsupported_background": "Pozadie obrázku",
			"unsupported_background": "Pozadie obrázku",
			"unsupported_background_description": "Porovnávače tovaru a inzertné siete sa líšia v požiadavkách na pozadie produktových obrázkov. Veľká časť z nich vyžaduje jednofarebné biele pozadie. Ak na ne odošlete obrázky alebo produktové fotografie s farebným pozadím, nedostanete tieto produkty do inzercie. Na niektorých porovnávačoch to ale naopak možné je.",
			"set_watermark_group_first": "Najskôr nastavte skupinu vodoznakov!",
			"unknown_preview_image_error": "Chyba načítavania obrázku",
			"render_preview_error_6": "Neznáma doména",
			"render_preview_error_1": "Zdrojový obrázok je prázdny",
			"render_preview_error_420": "Neznámy formát",
			"render_preview_error_450": "PNG obrázok má zlý CRC",
			"render_preview_error_28": "Server na ktorom je obrázok nezodpovedá",
			"render_preview_error_35": "Chyba SSL",
			"first_steps_wizard": "Sprievodca prvým nastavením",
			"skip_wizard": "Nepotrebujem sprievodcu, chcem prejsť do aplikácie",
			"close_wizard": "Zavrieť sprievodca",
			"input_elements_map": "Nastavenie vstupných elementov",
			"input_output_format": "Nastavenie vstupného a výstupného formátu",
			"first_steps_create_template": "Hotovo. Všetko je pripravené na tvorbu prvej šablóny.",
			"first_step_info": "Vitajte v aplikácii Feed Image Editor, ktorá vám pomôže s hromadnou úpravou produktových obrázkov vášho e-shopu pre marketplace, sociálne siete a tovarové porovnávače.<br/>V prvom kroku si prosím vyberte kanál, na ktorom chcete inzerovať:",
			"first_step_info_old": "Vitajte v aplikácií Feed Image Editor, ktorá vám pomôže s úpravou obrázkov vo vašom e-shope. <br/>Ako prvý krok prosím skontrolujte, či sme vybrali správne elementy z vášho feedu pre použitie v editore. Potom sa už môžete hneď pustiť do tvorby prvej šablóny.",
			"next_step": "Ďalší krok",
			"previous_step": "Predošlý krok",
			"input_format": "Vstupný formát",
			"output_format": "Výstupný formát",
			"preferred_product_preview": "Náhľad preferovaného produktu",
			"date_placeholder": "DD. MM. RRRR",
			"today": "Dnes",
			"news_box_header": "Pozrite si novinky v aplikácii",
			"news_box_body": "<h4>Upravujte produktové obrázky priamo v chate</h4><p>Feed Image Editor má teraz MCP server – prepojenie s AI asistentmi ako Claude alebo ChatGPT. Namiesto klikania v rozhraní stačí zadať príkaz v chate a agent za vás:<ul><li>nastaví šablóny a parametre úprav</li><li>priradí produkty podľa výberu</li><li>upraví rozmery, odstráni pozadie, zvýší rozlíšenie</li></ul></p><p>Ak už máte AI asistenta pripojeného cez Mergado MCP, Feed Image Editor MCP funguje automaticky a bez ďalšieho nastavovania. V prípade, že ste ešte s MCP nepracovali, kliknite na odkaz a behom chvíľky ho napojíte.</p>",
			"news_box_body_link": "Zistiť viac →",
			"select_template_queries": "Najprv vyberte, na aké produkty chcete šablónu aplikovať",
			"set_output_image_size": "Nastavte si veľkosť výstupných obrázkov",
			"select_from_template_gallery": "Môžete si vybrať niektorú z našich pripravených šablón",
			"main_image_or_collage": "Zvoľte si, či chcete mať na výstupe iba hlavný obrázok alebo koláž hlavného a alternatívnych obrázkov",
			"main_image_on_canvas_placement": "Umiestnite hlavný obrázok na plátno",
			"set_collage_layout": "Nastavte výsledný vzhľad koláže. Pre lepší efekt odporúčame aktivovať fuknciu odstránenia pozadia.",
			"set_anim_gif": "Nastavte výsledný vzhľad animovaného GIFu",
			"position_and_rotation": "Pozícia a pootočenie",
			"apply_ai_effects_or_filters": "Aplikujte AI efekty alebo filtre na produktový obrázok",
			"editor_step_5": "Zvoľte si, či má byť šablóna spustená hneď po vytvorení alebo až vo vybraný deň",
			"editor_step_6": "Vizuálna podobnosť obrázkov",
			"editor_step_7": "Pridajte si ďalšie vrstvy s grafickými prvkami",
			"helper_tips": "<ul><li>Chceli by ste v appke používať vlastný font? Napíšte nám na support@feedimageeditor.com</li><li>Viete, že v editore môžete používať klávesové skratky?<div class='quote'><span class='framed'>Ins</span><span>Vložiť novú vrstvu</span><br/><span class='framed'>Del</span><span>Zmazať vrstvu</span><br/><span class='framed'>Ctrl + s</span><span>Uložiť šablónu</span><br/><span class='framed'>Ctrl + z</span><span>Editácia späť</span><br/><span class='framed'>Ctrl + y</span><span>Editácia znova</span><br/><span class='framed'>Ctrl + c</span><span>Kopírovať vrstvu</span><br/><span class='framed'>Ctrl + v</span><span>Vložiť vrstvu</span></div></li></ul>",
			"more_fonts": "Chceli by ste v appke používať vlastný font? Napíšte nám na <a href=\"mailto:support@feedimageeditor.com\" class=\"mail-link\">support@feedimageeditor.com</a>",
			"editor_step_0": "Vyberte typ šablóny",
			"layout": "Rozvrhnutie obrázkov",
			"autoonoff": "Plánovač aktivity",
			"success": "V poriadku",
			"zoom": "Priblíženie",
			"pan": "Posúvanie",
			"draw": "Kresliť",
			"move": "Posunúť",
			"reset_zoom": "Reset zoom",
			"queued_at": "Zaradené do fronty",
			"score": "Skóre",
			"ai_tools": "AI nástroje",
			"missing_symbols": "Tento font neobsahuje všetky symboly, živý náhľad a vyrenderovaný obrázok sa môžu líšiť.",
			"characters": "znaky",
			"recently_used": "Nedávno použité",
			"set_background": "Nastaviť pozadie",
			"filters": "Filtre",
			"remove_background_error": "Nastala chyba pri odstraňovaní pozadia obrázku",
			"cannot_remove_background": "U daneho obrazku nedokazeme odstranit vierohodne pozadie",
			"object_to_image_ratio": "Objekt/obrázok",
			"template_id": "template id",
			"disable_show_overlap": "Nezobrazovať zónu v náhľade",
			"font_example": "Kŕdeľ ďatľov učí koňa žrať kôru.",
			"unsupported_mime_type": "Nepodporovaný formát",
			"unsupported_file_size": "Súbor je príliš veľký",
			"selection": "Výber",
			"is_transparent": "Priehľadné pozadie",
			"is_light_bg": "Svetlé pozadie",
			"orientation": "Orientácia obrázku",
			"portrait": "Na výšku",
			"landscape": "Na šírku",
			"bg_color_distance": "Farebná vzdialenosť",
			"small_distance": "malá",
			"big_distance": "veľká",
			"medium_distance": "stredná",
			"bg_color": "Farba pozadia",
			"create": "Vytvoriť",
			"create_predefined_fie_queries_title": "Ktoré z nasledujúcich výberov si prajete vytvoriť?",
			"create_predefined_fie_queries_text": "Vytvoriť preddefinované FIE výbery?",
			"active_supereffect": "Aktívny superefekt",
			"not_number": "Nie je číslo",
			"prepared_text": "Predchystaný text",
			"get_now": "akcia",
			"discount": "zľava",
			"discount_and_frame": "Zľava & rámček",
			"1_plus_1_circle": "1 + 1 ZADARMO",
			"buy_one_get_one_free": "1+1 zdarma",
			"last_piece": "Posledný kus",
			"new_year_sale": "Novoročný výpredaj",
			"free_gift": "darček zdarma",
			"add_to_cart": "do košíka",
			"sale": "výpredaj",
			"buy_now": "kúpiť teraz",
			"buy": "kúpiť",
			"order_now": "objednať",
			"free_delivery": "doprava zdarma",
			"newie": "novinka",
			"in_stock": "skladom",
			"project_health": "Zdravie projektu",
			"find_by": "Nájsť",
			"fonts": "Fonty",
			"send_mailgun_notifications": "Posielať systémové notifikácie a tipy na mail",
			"force_remove_alpha": "Odstránenie alpha kanála z obrázku pred posielaním na odstránenie pozadia",
			"auto_template_priority": "Automaticky usporiadať poradie šablón",
			"no_watermark_mask_defined": "Najskôr musíte označiť masku vodoznaku",
			"brush": "Štětec",
			"eraser": "Guma",
			"main_image_opt": "Hlavný obrázok",
			"layout_opt": "Koláž",
			"skip_refresh_images": "Sťahovať obrázky len pri zmene ich URL",
			"skip_refresh_images_hint": "Nevyťažuje toľko server s uloženými obrázkami. Pozn: pokiaľ url obrázku zostane rovnaká, iba sa zmení obsah, nemožno túto zmenu zistiť automaticky.",
			"or": "alebo",
			"preferred_product_id": "Preferované ID",
			"random_product_id": "Načítaný produkt",
			"other": "iný",
			"group_all_templates": "Všetky šablóny",
			"group_discounts_and_sales": "Akcie a zľavy",
			"group_black_friday": "Black Friday",
			"group_gift": "Darček zdarma",
			"group_free_delivery": "Doprava zdarma",
			"group_new_year_sale": "Novoročný výpredaj",
			"group_viva_magenta": "Viva Magenta",
			"group_midjourney": "Midjourney",
			"group_generic": "Univerzálne šablóny",
			"group_new": "Novinky",
			"group_seasonal": "Sezónne kampane",
			"group_availability": "Skladová dostupnosť",
			"group_christmas": "Vianočná kampaň",
			"group_effects": "Efekty",
			"group_background": "Pozadie",
			"group_warranty": "Záruka",
			"group_valentine": "Valentín",
			"group_size_variant": "Veľkostné varianty",
			"custom": "Vlastné",
			"no_watermark_groups_yet": "Zatiaľ nemáte žiadne skupiny vodoznakov.",
			"no_watermark_groups_published_yet": "Zatiaľ nemáte žiadne odoslané skupiny vodoznakov.",
			"start_here": "Začnite tu",
			"select_images_to_watermark_groups": "Vyberte niekoľko obrázkov s rovnakým vodoznakom.",
			"watermark_groups_info_0": "Pre každý typ vodoznaku je potrebné označiť niekoľko obrázkov rovnakým vodoznakom. Tieto obrázky sa použijú na trénovanie modelu.",
			"watermark_groups_info_1": "todo",
			"images_from_mergado": "Obrázky z MERGADA",
			"images_from_fie": "Produktové obrázky z pravidiel",
			"images_from_upload": "Nahrané obrázky",
			"select_images_with_same_watermark": "Vyberte obrázky",
			"create_watermark_mask": "Zamaľujte štetcom vodoznak",
			"create_watermark_group": "Vytvoriť",
			"create_new_watermark_group": "Vytvořit novou skupinu obrázků",
			"append_to_watermark_group": "Pripojiť",
			"to_wm_group": "do skupiny",
			"add": "Pridať",
			"add_image": "Pridať obrázok",
			"no_watermark_mask": "Označte prosím vodoznak",
			"publish_to_trainer": "Odoslať na trénovanie",
			"images_in_group": "Obrázky v skupine",
			"rename": "Premenovať",
			"group_exists": "Skupina s týmto názvom už existuje",
			"cannot_be_empty": "Nesmú byť prázdne",
			"sent": "Odoslané",
			"confirm_remove_group_image": "Zmazať obrázok zo skupiny vodoznakov?",
			"confirm_remove_group": "Zmazať skupinu vodoznakov",
			"empty_watermark_group": "Skupina vodoznakov neobsahuje žiadne obrázky. Začnite nahraním obrázkov do skupiny.",
			"unpublished_group": "Skupina nebola odoslaná na trénovanie modelu",
			"watermark_group_hash_diff": "Skupina bola zmenená. Je potrebné odoslať znova na trénovanie.",
			"watermark_group_some_images_without_mask": "Niektoré produkty v tejto skupine nemajú označený vodoznak.",
			"spacing": "Mezery",
			"line_spacing": "Riadkovanie",
			"letter_spacing": "Prestrkanie",
			"lines_and_letters_spacing": "Medzery medzi písmenami",
			"publish_to_detector": "Odoslať do detektora vodoznakov",
			"published": "Odoslané",
			"no_gradients_yet": "Zatiaľ nemáte vytvorený žiadny gradient",
			"results": "Výsledky",
			"no_results_yet": "Zatiaľ žiadne výsledky",
			"template_name_max_100": "max dĺžka názvu je 100 znakov",
			"clockwise": "V smere hodinových ručičiek",
			"counter_clockwise": "Proti smeru hodinových ručičiek",
			"no_color": "žiadna",
			"text_stroke": "Ťah textu",
			"text_stroke_underlayer": "Obrys ako podklad (nemení sa hrúbka textu)",
			"text_stroke_inside": "Obrys okolo textu na úkor hrúbky textu",
			"text_padding": "Odsadenie textu",
			"select_format_to_see_templates": "Ak chcete zobraziť grafické šablóny, najprv vyberte formát výstupného obrázka.",
			"warn_inactive_fie_queries": "Tieto preddefinované výbery nie sú aktívne",
			"warn_rules_not_applied_yet": "Tieto výbery ešte nie sú v zozname, pretože neprebehli pravidlá",
			"random_colors": "Náhodné farby",
			"random_gradients": "Náhodné prechody",
			"dominant_color": "Farba z produktu",
			"warn_transparent_background": "Ak chcete mať <b>priehľadné pozadie</b> výstupných obrázkov, vyberte v Nastaveniach ako výstupný formát .png.",
			"import_palette": "Importovať paletu",
			"delete_palette": "Odstrániť paletu",
			"add_color": "Pridať farbu",
			"group_easter_campaign": "Veľkonočná kampaň",
			"happy_easter": "Veselá Veľká noc",
			"easter_discounts": "veľkonočné zľavy",
			"easters": "VEĽKONOČNÉ",
			"spring": "JARNÉ",
			"spring_sales": "Jarný výpredaj",
			"spring_discounts": "Jarné zľavy",
			"discounts": "ZĽAVY",
			"discount_30": "ZĽAVA 30%",
			"discounts_30": "ZĽAVY -30%",
			"up_to_20": "až 20%",
			"right": "PRÁVE",
			"now": "TERAZ",
			"click_here": "KLIKNI TU",
			"buy_here": "NAKUPUJ TU",
			"watermark_mark_images": "Vyberte a označte 10 až 15 obrázkov, ktoré obsahujú rovnaký vodoznak.",
			"watermark_max_images": "Max 15 obrázkov",
			"watermark_min_images": "Min 10 obrázkov",
			"marked_watermarks": "označených vodoznakov",
			"not_published_yet": "zatiaľ neodoslané",
			"text_orientation": "Orientácia textu",
			"horizontal_orientation": "vodorovne",
			"vertical_orientation": "zvisle",
			"clip_mask": "Maska orezu",
			"add_clip_mask": "Pridať masku orezu",
			"invert_clip_mask": "Invertovať masku orezu",
			"finish": "Skončiť",
			"watermark_is_marked": "Vodoznak je označený",
			"already_used_image": "Obrázok bol už použitý",
			"check_elements_title": "Overenie dostupnosti ručne zadaných elementov",
			"some_elements_not_available": "Zdá sa, že niektoré z ručne zadaných elementov nie sú dostupné. Navrhované zmeny:",
			"apply_all_suggested_changes": "Aplikovať všetky navrhované zmeny",
			"apply_only_selected_changes": "Aplikovať vybrané zmeny",
			"template_layer": "Vrstva šablóny",
			"e_img_url": "Element s adresou obrázku",
			"e_img_url_input": "Vstupný element s adresou obrázku",
			"e_alt_img_url": "Element s adresou alternatívneho obrázku",
			"e_alt_img_url_input": "Vstupný element s adresou alternatívneho obrázku",
			"e_item_id": "Element s ITEM ID",
			"e_name": "Element s názvom produktu",
			"e_productno": "Element s číslom produktu",
			"e_price_vat": "Element s cenou",
			"e_url": "Element s adresou do obchodu",
			"e_ean": "EAN element",
			"template": "šablóna",
			"layer": "vrstva",
			"audit_promo_templates": "Ukážkové šablóny v audite",
			"save_and_rerender_promo": "Uložit a vyrenderovat promo u existujích projektů",
			"reload_saved": "Znovu načíst uložené",
			"back_to_predefined": "Zpět předdefinované",
			"reset_filters": "Zrušiť filtre",
			"has_complex_background": "Komplexné pozadie",
			"complex_background_threshold": "prah pre komplexné pozadie",
			"empty_background_probability": "pravdepodobnosť prázdneho pozadia",
			"object_bounding_box_to_image_ratio": "pomer rámčeka ohraničenia objektu k obrázku",
			"set_template_size": "Nastaviť rozmery šablóny (odporúča sa)",
			"keep_original_image_size": "Ponechať pôvodné rozmery obrázku",
			"no_template_size_is_selected_title": "Chýba rozmery šablóny",
			"no_template_size_is_selected": "Nemáte vybrané rozmery šablóny. Pokiaľ máte v šablóne ďalšie vrstvy, môžu byť mimo viditeľnú oblasť.",
			"gradient_stop_points": "koncové farby gradientu",
			"is_autocrop": "Autocrop",
			"new_alternative_template": "Nová šablóna alternatívnych obrázkov",
			"alternative_template": "Šablóna alternatívnych obrázkov",
			"alternative_templates": "Šablóny alternatívnych obrázkov",
			"main_templates": "Šablóny hlavných obrázkov",
			"image_offset": "Posun obrázku voči vymedzenému tvaru",
			"collage_image_shape": "Tvar",
			"rect": "Obdĺžnik",
			"ellipse": "Elipsa",
			"selected": "Vybraté",
			"import": "Import",
			"no_templates_found": "Nenájdené žiadne šablóny",
			"auto_priority": "Automaticky usporiadať",
			"manual_priority": "Usporiadať ručne",
			"right_now": "PRÁVĚ TEĎ",
			"limited_offer": "OMEZENÁ NABÍDKA",
			"sale2": "AKCIA",
			"sales_up_to_50": "SLEVY AŽ 50%",
			"sale_up_to_50": "SLEVA AŽ 50%",
			"sales_up_to": "SLEVY AŽ",
			"this_week": "TENTO TÝDEN",
			"shop_here": "nakupuj zde",
			"discounts2": "SLEVY",
			"textInsideShape": "Text vo vnútri tvaru",
			"element_not_selected": "nebol vybraný element",
			"invalid_color": "neplatná farba",
			"invalid_email": "neplatný email",
			"letter_case": "Veľkosť písmen",
			"keep": "bez zmien",
			"to_upper_case": "na veľké písmená",
			"to_lower_case": "na malé písmená",
			"first_letter_to_upper_case": "prvé písmeno veľké",
			"first_letter_to_lower_case": "prvé písmeno malé",
			"first_word_letter_to_upper_case": "prvé písmeno v slove veľké",
			"has_person": "Postava v obrázku",
			"person_detected": "postava detekována",
			"person_not_detected": "postava nedetekována",
			"columns": "Stĺpce",
			"is_keep_size": "Zachovať pôvodný formát",
			"is_keep_size_info": "Máte vybrané ponechať pôvodné rozmery. Nie je možné vkladať vrstvy, iba efekty.",
			"contact_email": "Kontaktný email",
			"element_short_item_id": "ITEM_ID",
			"element_short_url": "URL",
			"element_short_cpc": "CPC",
			"element_short_name": "NAME",
			"element_short_img_url": "IMG_URL",
			"element_short_img_url_input": "IMG_URL",
			"element_short_alt_img_url": "IMG_ALTERNATIVE",
			"element_short_alt_img_url_input": "IMG_ALTERNATIVE",
			"element_short_price_vat": "PRICE_VAT",
			"element_short_delivery_date": "DELIVERY_DATE",
			"element_short_manufacturer": "MANUFACTURER",
			"element_short_categorytext": "CATEGORY",
			"element_short_ean": "EAN",
			"steps_first_perex": "<h4>Vitajte v rozšírení Feed Image Editor</h4><p class='perex'>Pomôžeme vám rýchlo a jednoducho upravovať produktové obrázky pre váš e-shop. Aby všetko fungovalo správne, spoločne nastavíme niekoľko základných krokov.</p>",
			"steps_last_perex": "Teraz sa môžete pustiť do zdokonaľovania svojich produktových obrázkov. Vyberte si, s akými úpravami chcete začať v úvodnej šablóne.",
			"steps_first_header": "Skontrolujte elementy vo vašom Mergado feede",
			"steps_first_subheader": "Skôr než začnete vytvárať prvú šablónu alebo kampaň, uistite sa, že sme správne vybrali kľúčové elementy z vášho produktového feedu. Slúžia na to, aby sa do obrázkov dopĺňali správne informácie, ako napríklad cena, názov, značka alebo dostupnosť.",
			"steps_need_inspiration_perex": "Nájdite ju v editovateľných šablónach, ktoré sme pre vás pripravili.",
			"steps_need_inspiration": "Potrebujete inšpiráciu?",
			"first_steps_title": "Sprievodca prvým nastavením",
			"steps_third": "Zostaňme v kontakte",
			"steps_third_subscribe": "Prihlasujem sa tiež na odber newslettera",
			"create_first_template": "Vytvoriť prvú šablónu",
			"steps_create_blank": "Pridanie grafických prvkov a CTA",
			"steps_create_resize": "Zmena veľkosti na konkrétny formát",
			"steps_create_upscale": "Vylepšenie kvality",
			"steps_create_bg_removal": "Odstrániť pozadie",
			"steps_create_watermarks": "Odstrániť vodoznak",
			"steps_create_header": "Hotovo! Môžete začať tvoriť",
			"steps_create_perex": "Všetko je pripravené. Teraz môžete začať upravovať svoje produktové obrázky a vytvárať prvé šablóny.",
			"steps_who_are_you_title": "Aby sme vám mohli odporučiť tie správne funkcie a nastavenia, povedzte nám, kto ste.",
			"steps_who_are_you_subtitle": "Vďaka tomu vám nastavíme služby presne na mieru.",
			"steps_categorization_title": "Aký typ e-shopu prevádzkujete?",
			"steps_categorization": "Vyberte kategóriu, ktorá najlepšie zodpovedá vášmu sortimentu. Vďaka vašej odpovedi vám poskytneme lepšie služby presne na mieru.",
			"steps_third_email": "Vaša e-mailová adresa",
			"steps_third_sublabel": "Budeme vám posielať systémové upozornenia, keď nastane čokoľvek dôležité.",
			"steps_second": "Výstupné nastavenia",
			"output_image_format_sublabel": "Vyberte výstupný formát obrázkov.",
			"output_image_compression_sublabel": "Nastavenie úrovne kvality kompresie.",
			"auto_compression_to_size_sublabel": "Redukcia dátovej veľkosti",
			"steps_third_email_sublabel": "Ak sa niečo dôležité stane, zašleme vám notifikáciu.",
			"visual_similarity": "Vizuálna podobnosť",
			"ai_params": "Doplnenie parametrov do produktov",
			"ai_params_generate": "Vygenerovať parametre z obrázkov do feedu",
			"ai_params_is_running_on_background": "Na pozadí prebieha AI analýza obrázkov a generovanie parametrov",
			"similar_images": "podobné obrázky",
			"find_similar_images": "Nájsť podobné obrázky",
			"searching_in_progress": "Prebieha vyhľadávanie",
			"create_list_and_publish_to_visual_similarity": "Exportovať obrázky v šablóne a nájsť podobné",
			"visual_similarity_last_update_at": "Funkcia vizuálnej podobnosti je momentálne vypnutá. Výsledky sú aktuálne k ",
			"image_cannot_be_downloaded": "Obrázok sa nedá stiahnuť",
			"product_has_no_image": "Produkt nemá obrázok",
			"missing_image_element": "Chýba obrázkový element",
			"visual_similarity_enabled": "Nájsť podobné obrázky",
			"visual_similarity_n": "Počet podobných obrázkov",
			"visual_similarity_threshold": "Index podobnosti",
			"visual_similarity_search_products_in": "Hľadať podobné v šablónach",
			"feature_enabled": "Funkcia je zapnutá",
			"feature_disabled": "Funkcia je vypnutá",
			"upload_images": "Nahrať obrázky",
			"download_images": "Stiahnuť obrázky",
			"download_image": "Stiahnuť obrázok",
			"upload_image": "Nahrať obrázok",
			"uploaded_images": "Nahrané obrázky",
			"external_image": "Grafické prvky",
			"blog_link": "https://www.feed-image-editor.sk/blog",
			"please_select_templates": "Vyberte šablóny, v ktorých chcete hľadať podobné produkty",
			"loading_results": "Načítavam výsledky",
			"exporting": "Exportujem produkty",
			"task_queued": "Task zaradený do frontu",
			"waiting_before_publish": "Čakám pred odoslaním tasku",
			"popup_box_header": "Důležité oznámení. Měníme cenu za Feed Image Editor",
			"popup_box_body": "<p>Dobrý den,<br/><br/>od <b>1. 9. 2024</b> upravujeme cenu za aplikaci Feed Image Editor. Výše měsíčního poplatku bez DPH bude 1986 Kč (79 €). Máme pro vás však výhodnou nabídku. Pokud jste již naším klientem, máte měsíční fakturační období a do 31. 7. 2024 <b>přejdete na roční, budete mít celý rok aplikaci za 1028,8 Kč bez DPH (38,4 €) na měsíc</b>. Nabídka platí také pro nové klienty, kteří si aplikaci na rok předplatí do 31. 7. 2024.</p><p>⇨ podrobně popsané scénáře přechodu na nový ceník najdete na <span class=\"link\" onClick=Mergado.openWindow(\"https://preview.mailerlite.io/preview/540026/emails/127288531702777107\")>tomto odkazu</span><p/><p>Roční fakturace vám navíc přinese 20% slevu na Mergado a všechny další aplikace z Mergado Store. Čas na to máte do 31. 7. 2024 (včetně).<p/><p>Cena je uvedena za jeden projekt.</p>",
			"understand": "Rozumiem",
			"rerender": "Pregenerovať",
			"redownload": "Znovu stiahnuť",
			"to_be_processed": "Zostáva spracovať",
			"similarity_less_than_n": "K danému produktu sa pri zvolenej hodnote indexu podobnosti nepodarilo dohľadať zvolený počet podobných obrázkov. Zvážte zníženie hodnoty indexu podobnosti.",
			"similarity_n_limit_info": "Nastavte počet podobných obrázkov, ktorý sa má k danému produktu vyhľadať. K niektorým produktom sa pri danej hodnote indexu podobnosti nemusí nutne tento počet vyhľadať. V takom prípade zvážte zníženie hodnoty indexu podobnosti.",
			"similarity_threshold_info": "Index podobnosti určuje mieru, ako veľmi podobné obrázky sa majú k produktu vyhľadať. Čím vyššia hodnota, tým podobnejšie obrázky. Hodnota 1 vyhľadá úplne rovnaké obrázky.",
			"fill_similarity_title": "Zapisovanie výsledkov do výstupného feedu",
			"fill_similarity_ids_element": "ID vizuálne podobných produktov",
			"fill_similarity_image_urls_element": "URL adresy vizuálne podobných obrázkov",
			"no_items_filtered": "Nenašli sme žiadny výber",
			"no_match_with_element_regexp": "Element nevyhovuje filtru elementov pre aplikáciu pravidiel (element_regex)",
			"advanced_settings": "Pokročilé nastavenia",
			"mergado_max_payload_size": "Maximálny počet znakov odoslaných v jednom requeste. Maximálna možná hodnota je 15 000 000 znakov.",
			"mergado_element_regex": "Regularný výraz podľa ktorého budú filtrované elementy projektu",
			"mergado_xml_equivalent": "Mergado XML elementy, ktorých ekvivalent pre daný formát bude odoslaný z Mergada.",
			"suggested_elements_to_be_excluded": "Navrhované elementy, ktoré môžete vynechať pri aplikácii pravidiel",
			"alt_levels": "Úrovne obrázkov alternatívnej šablóny",
			"levels": "Úrovne aplikovania",
			"assigned_templates": "Priradené hlavné šablóny",
			"no_assigned_templates": "Žiadne priradené šablóny",
			"necessary": "Nevyhnutné",
			"exclude_some": "Vynechať vybrané",
			"regexp": "Regulárny výraz",
			"mergado_apply_elements": "Ktoré elementy sa majú do FIE posielať pri aplikácii pravidiel",
			"necessary_elements": "Elementy nevyhnutné pre chod FIE",
			"selected_mergado_equivalent": "Vybrané ekvivalenty Mergado elementov",
			"categories": "Kategórie",
			"fashion": "Móda",
			"beauty": "Krása",
			"health": "Zdravie",
			"pets": "Domáce zvieratá",
			"electronics": "Elektronika",
			"home_and_garden": "Domov a záhrada",
			"kids": "Deti",
			"sports": "Športy",
			"books": "Knihy",
			"cars": "Autá",
			"services_and_experiences": "Služby a skúsenosti",
			"other_category": "Iné",
			"back_to_original": "Vrátiť pozadie",
			"paint_transparent": "Odstrániť pozadie",
			"waiting_for_product_to_be_loaded": "Čaká sa na načítanie produktu",
			"should_rerender": "Malo by sa znova vykresliť",
			"should_redownload": "Malo by sa znova stiahnuť",
			"has_alt_images": "Má alternatívne obrázky",
			"anim-gif": "Anim GIF",
			"auto-wmremove": "Odstránenie vodoznakov",
			"format_preset": "Predchystaný",
			"format_original": "Pôvodný",
			"format_custom": "Vlastný",
			"turned_off": "vypnuté",
			"mode": "režim",
			"inpainting_create_mask": "Vyznačte oblasti pre inpainting.",
			"inpainting_how_to_deal_with_diff_size": "Ako prispôsobiť rôzne veľkosti masky a obrázku",
			"position_relative_to": "Pozícia relatívna voči",
			"scale_mask_to_image_size": "Naškálovať masku na veľkosť obrázku",
			"scale_to_size": "Prispôsobiť veľkosť",
			"object_position": "Poloha objektu",
			"complex_background": "Komplexné pozadie",
			"edit_element_content": "Upraviť obsah elementu",
			"prefix": "text pred",
			"suffix": "text za",
			"decimals": "počet miest",
			"separator": "oddeľovač",
			"replace": "nahradiť",
			"find_as_regexp": "nájsť ako regulárny výraz",
			"symbol_table": "Špeciálne symboly mien",
			"find_and_replace": "Nájsť a nahradiť",
			"add_text": "Vložiť text",
			"decimal_places": "Desatinné miesta",
			"thousands_separation": "Oddeliť tisíce",
			"short_url_with_extension": "Kratšie url s príponou súboru",
			"short_url_with_extension_info": "Kratšia forma výstupnej url adresy zahŕňajúca príponu podľa výstupného formátu obrázku. Niektoré porovnávače vyžadujú príponu obrázku v adrese.",
			"gradient_is_used_by_template": "Tento gradient je používaný šablónou a nemožno ho teda zmazať.",
			"no_search_image_results": "Neboli nájdené žiadne obrázky zodpovedajúce hľadanému výrazu.",
			"import_from_project": "Import z projektu",
			"choose_project": "Zvoľte projekt",
			"no_other_projects_of_user": "Žiadne projekty z ktorých je možné importovať.",
			"loading_queries": "Načítavam výbery z Mergada",
			"loading_template": "Načítavam šablónu",
			"text_mode": "Textový režim",
			"total_icons": "Počet ikon",
			"try_icons": "Vyskúšať ikony",
			"icon_color": "Farba ikon",
			"did_not_found_stickers": "Nenašli ste vhodné samolepky?",
			"ai_elements_to_feed": "Obohatenie feedu pomocou AI",
			"mcp": "MCP",
            }
        }
    